import React, { memo } from 'react';
import { Link, useLocation } from 'react-router-dom';

const MenuItemLink = ({ menuItem }) => {
    const location = useLocation();
    const isActive =
        location.pathname === menuItem.link ||
        (menuItem.link !== '/' &&
            location.pathname.startsWith(menuItem.link));
    const active = isActive ? 'active' : '';

    return (
        <Link to={menuItem.link} className={active}>
            <img
                src={menuItem.icon}
                className="w-32"
                alt={menuItem.name}
            />
            <span>{menuItem.name}</span>
        </Link>
    );
};

const MenuChildLink = ({ item }) => {
    const location = useLocation();
    const isActive =
        location.pathname === item.link ||
        (item.link !== '/' && location.pathname.startsWith(item.link));
    const active = isActive ? 'active' : '';

    return (
        <li className={active}>
            <Link to={item.link}>{item.name}</Link>
        </li>
    );
};

const MenuItem = ({ menu }) => {
    const showParent = (menuItem) => {
        let xhtml = null;
        if (menuItem.children) {
            xhtml = (
                <span className="ref-a">
                    <img
                        src={menuItem.icon}
                        className="w-32"
                        alt={menuItem.name}
                    />
                    <span>{menuItem.name}</span>
                </span>
            );
        } else if (menuItem.link) {
            xhtml = <MenuItemLink menuItem={menuItem} />;
        }
        return xhtml;
    };

    const showChildren = (menuItem) => {
        const xhtml = [];
        if (menuItem.children) {
            menuItem.children.forEach((item, index) => {
                xhtml.push(
                    <MenuChildLink key={index} item={item} />,
                );
            });
        }

        return xhtml.length === 0 ? '' : <ul>{xhtml}</ul>;
    };

    return (
        <li className="li-main">
            {showParent(menu)}
            {showChildren(menu)}
        </li>
    );
};
export default memo(MenuItem);
